import { useContext, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Settings } from "./components/Configurations/Configurations";
import { setGridVisibility, setSpaceVisibility, ToggleInvisibleAsXray } from "./Context/ViewerContext/Reducer";
import { ViewerContext } from "./Context/ViewerContext/ViewerContextProvider";
import i18n from "./i18n/i18n";
import DStudioViewer from "./Models/DstudioViewer";
import FireBimViewer from "./Pages/FireBim/FireBim";
import KpdViewer from "./Pages/Kpd/KpdViewer";
import Viewer from "./Pages/Viewer/Viewer";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

interface Webview {
    postMessage: (message: string) => void;
}

interface Chrome {
    webview: Webview;
}

declare global {
    interface Window {
        bimcradle: DStudioViewer | undefined;
        chrome: Chrome;
    }
}

function App() {
    const { dispatch } = useContext(ViewerContext);

    useEffect(() => {
        const settingsString = localStorage.getItem("viewerSettings");
        if (settingsString) {
            const settings: Settings = JSON.parse(settingsString);
            i18n.changeLanguage(settings.language);
            dispatch(setGridVisibility(settings.gridEnabled));
            dispatch(setSpaceVisibility(settings.spaceEnabled));
            dispatch(ToggleInvisibleAsXray(settings.invisibleAsXray));
        }
    }, []);

    return (
        <Routes>
            <Route path="/" element={<Viewer />} />
            <Route path="/kpd" element={<KpdViewer />} />
            <Route path="/sb2" element={<KpdViewer />} />
            <Route path="/firebim" element={<FireBimViewer />} />
        </Routes>
    );
}

export default App;
